import angular from 'angular';

(function() {
    'use strict';

    angular.module('app.core').component('kissLabel', {
        bindings: {
            label: '<' // Libellé
        },
        templateUrl: require('./kiss-label.html')
    });
})();
